import AbstractModel from "../abstract";


export default class BusinessAddress extends AbstractModel{
    constructor(data){
        super();

        this.location = "";
        this.name = "";
        
        this.setData(data);
    }

    load(id, onLoaded=null, onError=null){
        this.api.get("/business/address/" + id)
            .then(results => {
                this.id = results.address.id;
                this.name = results.address.name;
                this.location = results.address.address;
                
                if(onLoaded)
                    onLoaded();
            })
            .catch(onError);
    }

    save(onSaved=null, onError=null){
        let route = "/business/addresses";
        if(this.id)
            route += "/" + this.id;
        let data = {
            address: this.location,
            name: this.name
        };
        let callback = (results) => {
            if(!this.id)
                this.id = results.address.id;
            this.name = results.address.name;
            this.location = results.address.address;

            if(onSaved)
                onSaved();
        };

        if(!this.id)
            this.api.post(route, data).then(callback).catch(onError);
        else
            this.api.put(route, data).then(callback).catch(onError);
    }

    del(onDeleted=null, onError=null){
        if(this.isLoaded()){
            this.api.del("/business/addresses/" + this.id)
                .then(() => {
                    this.id = null;
                    if(onDeleted)
                        onDeleted();
                })
                .catch(onError);
        }
    }

    getLabel(){
        let lbl = this.location;
        if(this.name)
            lbl = this.name + " - " + lbl;
        return lbl;
    }
}


// WEBPACK FOOTER //
// ./src/models/business/address.js